<template lang='pug'>

  v-app#pages-layout

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    sos-version

    app-bar

    v-main(id="pages" :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'")
      router-view

    sos-footer

</template>

<!-- SENHOR JESUS -->
<!-- Usado na tela de CONVITE -->
<!-- SENHOR JESUS -->

<script>

  import { mapState } from 'vuex'

  import { apiLogout } from '@/services/index.js'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import AppBar from './AppBar'
  import Footer from './Footer'

  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosVersion from '@/components/SosVersion'

  export default {
    name: 'PagesIndex', // 404 e JoinGroup (Link de convite externo)

    components: {
      /* 'app-bar': () => import('./AppBar'),
      footer: () => import('./Footer'),
      view: () => import('./View'), */

      'app-bar': AppBar,
      'sos-footer': Footer,
      'sos-version': SosVersion,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    computed: {
      ...mapState(['dialogLogout']),
    },

    watch: {
      '$store.state.dialogLogout': {
        deep: true,
        immediate: true, // the callback will be called immediately after the start of the observation
        handler (newDialogLogoutStatus, oldDialogLogoutStatus)
        {
          if (!!oldDialogLogoutStatus === false && !!newDialogLogoutStatus === true) {
            // console.log('::: THE LOGOUT CONFIRMATION DIALOG IS OPEN')

            this.showConfirmBox({ title: 'Atenção!', text: 'Você deseja encerrar sua sessão no SOS Gestor?', type: 'doLogout', data: '', isResponse: false, buttonPosition: 'right', width: 330, closeText: 'Não', continueText: 'Sair!' })
          }

          /* if (!!oldDialogLogoutStatus === true && !!newDialogLogoutStatus === false) {
            // [24/01/25] console.log('::: THE LOGOUT CONFIRMATION DIALOG IS CLOSED')
          } */
        },
      },
    },

    created () {
      this.$vuetify.theme.dark = true
    },

    beforeDestroy () {
      this.$vuetify.theme.dark = false
    },

    methods: {
      async cdAction (cdResponse)
      {
        this.$store.commit('ASK_LOGOUT', false)

        if (cdResponse === false) return

        if (cdResponse.cdType === 'doLogout') apiLogout()
      },
    },
  }

</script>

<style lang="sass" scoped>

  #pages-layout
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/auth-background.png')
    background-position: top
    background-repeat: no-repeat
    background-attachment: center
    background-size: cover

    color: rgba(0, 0, 0, 0.87)

  // .theme--light.v-application
    // background: #FFFFFF
    // color: rgba(0, 0, 0, 0.87)

</style>
